<template>
  <div>
    <Head :title="form.name" />
    <div class=" m-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-1">
      <div>
        <h1 class="mb-8 text-3xl font-bold">
          <Link class="text-indigo-400 hover:text-indigo-600" href="/orders">Orders</Link>
          <span class="text-indigo-400 font-medium">/</span>
          #{{ order.order_id }}
        </h1>
      </div>
      <div class="text-right">
        <a :href="`https://live-5203.wati.io/teamInbox/?filter={&quot;filterType&quot;:0}&search={&quot;searchString&quot;:&quot;${order.phone_number}&quot;}`" target="_blank" class="mt-2 ml-2 text-white bg-green-700 hover:bg-green-800 focus:outline-none focus:ring-4 focus:ring-green-300 font-medium rounded-full text-sm px-5 py-2.5 text-center mr-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800">
          <icon name="whatsapp" class="mr-2 w-4 h-4" :class="'inline-flex fill-white group-hover:fill-white'" />
          Send WhatsApp Message</a>
        <a :href="`tel:${order.phone_number}`" target="_blank" class="mt-2 ml-2 text-white bg-red-700 hover:bg-red-800 focus:outline-none focus:ring-4 focus:ring-green-300 font-medium rounded-full text-sm px-5 py-2.5 text-center mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
          <icon name="call" class="mr-2 w-4 h-4" :class="'inline-flex fill-white group-hover:fill-white'" /> Call
        </a>
        <a v-if="order.next_id" :href="`/orders/${order.next_id}`" class="mt-2 ml-2 text-white bg-black hover:border-gray-900 focus:outline-none focus:ring-4 focus:ring-green-300 font-medium rounded-full text-sm px-5 py-2.5 text-center mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
          <icon name="arrow-right" class="mr-2 w-4 h-4" :class="'inline-flex fill-white group-hover:fill-white'" /> Next
        </a>
      </div>
    </div>


    <div class=" m-auto grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1">
      <div class="bg-white rounded-md shadow overflow-hidden">
        <div class="flex flex-wrap -mb-4 -mr-3 p-4">
          <div class="pb-4 pr-3 w-full lg:w-1/5">Name:  <div class="pt-4 font-bold">{{ order.name }}</div></div>
          <div class="pb-4 pr-3 w-full lg:w-1/5">Phone:  <div class="pt-4 font-bold">{{ order.phone_number }}</div></div>
          <div class="pb-8 pr-3 w-full lg:w-1/5">Email:  <div class="pt-4 font-bold">{{ order.email }}</div></div>
          <div class="pb-4 pr-3 w-full lg:w-1/5">Total:  <div class="pt-4 font-bold">₹ {{ order.value }}</div></div>
          <div class="pb-8 pr-6 w-full lg:w-1/5">Order Date:  <div class="pt-4 font-bold">{{ order.ordered_at }} ({{ order.date_time }})</div></div>
          <div class="pb-4 pr-3 w-full lg:w-1/5">
            Shipping Address:
            <div class=" pb-4 font-bold">
              {{ order.shipping_address.address1 }}<br />
              <span v-if="order.shipping_address.address2">{{ order.shipping_address.address2 }}<br /></span>
              {{ order.shipping_address.city }}<br />
              {{ order.shipping_address.province }} {{ order.shipping_address.zip }}
            </div>
          </div>
          <div class="pb-4 pr-3 w-full lg:w-1/5">
            Billing Address:
            <div class=" pb-4 font-bold">
              {{ order.billing_address.address1 }}<br />
              <span v-if="order.billing_address.address2">{{ order.billing_address.address2 }}<br /></span>
              {{ order.billing_address.city }}<br />
              {{ order.billing_address.province }} {{ order.billing_address.zip }}
            </div>
          </div>
          <div class="pb-4 pr-3 w-full lg:w-1/5">Payment Method:  <div class="pt-4 pb-4 font-bold">{{ order.payment_method }}</div></div>
          <div class="pb-8 pr-6 w-full lg:w-1/5">Delivery ETA:  <div class="pt-4 font-bold">{{ order.delivery_eta }} days</div></div>
          <div v-if="order.confirmed_at" class="pb-4 pr-3 w-full lg:w-1/5">Confirmed At:  <div class="pt-4 pb-4 font-bold">{{ order.confirmed_at }}</div></div>
        </div>
        <!--          <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">-->
        <!--            <a :href="`https://organicbazar.net/wp-admin/post.php?post=${order.order_id}&action=edit`" target="_blank" class="btn-indigo ml-auto bg-blue-500">View Order</a>-->
        <!--          </div>-->
      </div>

      <div class=" m-auto w-full flex flex-wrap">
        <!--        <div class="mt-4 p-4 w-full bg-white rounded-md shadow overflow-hidden">-->
        <!--          <form @submit.prevent="update">-->
        <!--            <div class="x">-->
        <!--              <div class="pb-4 pr-3 w-full">-->
        <!--                <span class="w-full font-bold">Notes / History</span>-->
        <!--              </div>-->
        <!--              <hr>-->
        <!--              <form @submit.prevent="add_note">-->
        <!--                <div class="flex flex-wrap w-full">-->
        <!--                  <textarea-input v-model="note.note" :error="note.errors.note" class="pb-8 w-full" label="Note" />-->
        <!--                  <loading-button :loading="note.processing" class="btn-indigo mb-10" type="submit">Add Note</loading-button>-->
        <!--                </div>-->
        <!--              </form>-->

        <!--            </div>-->
        <!--          </form>-->
        <!--        </div>-->
        <div class="mt-4 p-4 w-full lg:w-1/2 bg-white rounded-md shadow overflow-x-hidden overflow-y-scroll">
          <div v-for="note in order.notes" class="flex flex-wrap w-full bg-orange-100 text-black p-2 rounded mb-2 overflow-x-hidden overflow-y-scroll">
            {{ note.note }}
            <span class="w-full pt-2"><small>{{ note.noted_at }}</small></span>
          </div>
          <div v-if="order.notes.length === 0" class="m-2 bg-green-50 p-4">
            No notes available at the moment.
          </div>
        </div>
        <div class="mt-4 p-4 w-full  lg:w-1/4 bg-white rounded-md shadow overflow-hidden">
          <div>
            <a :href="`https://admin.shopify.com/store/caed65-3/orders/${order.shopify_id}`" target="_blank" class="btn-indigo block w-full font-bold py-2 rounded-md hover:bg-blue-600 hover:text-white mb-4 text-left">
              <icon name="arrow-right" class="mr-2 w-4 h-4" :class="'inline-flex fill-white group-hover:fill-white'" /> View in Shopify
            </a>
            <a :href="`https://healthunbox.unicommerce.com/order/orderitems?orderCode=${order.shopify_id}#viewName=All&skipLocationChange=undefined`" target="_blank" class="btn-grey block w-full font-bold py-2 rounded-md hover:bg-blue-600 hover:text-white mb-4 text-left">
              <icon name="arrow-right" class="mr-2 w-4 h-4" :class="'inline-flex fill-white group-hover:fill-white'" /> View in Unicommerce
            </a>
<!--            <a :href="`https://organicbazar.net/wp-admin/admin.php?page=obz-customer-trace&email_phone=${order.phone_number}`" target="_blank" class="btn-indigo block w-full font-bold py-2 rounded-md hover:bg-blue-600 hover:text-white mb-4 text-left">-->
<!--              <icon name="arrow-right" class="mr-2 w-4 h-4" :class="'inline-flex fill-white group-hover:fill-white'" /> Track Customer-->
<!--            </a>-->
            <a :href="`https://admin.shopify.com/store/caed65-3/orders?query=${order.email}`" target="_blank" class="btn-indigo block w-full font-bold py-2 rounded-md hover:bg-blue-600 hover:text-white mb-4 text-left">
              <icon name="arrow-right" class="mr-2 w-4 h-4" :class="'inline-flex fill-white group-hover:fill-white'" /> Track Customer
            </a>
          </div>
        </div>
        <div class="mt-4 p-4 w-full lg:w-1/4 bg-white rounded-md shadow overflow-hidden">
          <div v-if="order.followups > 0 && order.status === 'hold'" id="alert-border-1" class="flex p-4 mb-4 bg-yellow-100 border-t-4 border-yellow-500 dark:bg-yellow-200" role="alert">
            <svg class="flex-shrink-0 w-5 h-5 text-yellow-700" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" /></svg>
            <div class="ml-3 text-sm font-medium text-blue-700">
              This order has <span class="font-bold">{{ order.followups }}</span> followups. Last followup at: {{ order.last_update }}
            </div>
          </div>
          <form @submit.prevent="update">
            <div class="w-full">
              <div class="pb-4 pr-3 w-full">
                <span class="w-full font-bold">Action</span>
              </div>
              <div v-if="order.status === 'dispatched' || order.status === 'cancel_completed'" class="w-full mr-5 mb-5">
                <div class="flex w-full p-4 bg-yellow-100 border-t-4 border-yellow-500 dark:bg-yellow-200">
                  <span class="text-black font-bold">This order has been dispatched or cancelled and no longer editable.</span>
                </div>
              </div>
              <div v-else class="w-full">
                <select-input v-model="form.status" :error="form.errors.status" class="pb-8 pr-6 w-full" label="Status">
                  <option :value="null" :selected="form.status == 'peding'" />
                  <option value="confirmed">Confirmed</option>
                  <option value="hold">On Hold</option>
                  <option value="cancelled">Cancel</option>
                </select-input>

                <select-input v-show="form.status === 'cancelled'" v-model="form.cancel_reason" :error="form.errors.cancel_reason" class="pb-8 pr-6 w-full" label="Cancel Reason">
                  <option v-for="(value, key) in cancel_reasons" :value="key" :selected="key === order.cancel_reason">{{ value }}</option>
                </select-input>

                <select-input v-show="form.status === 'hold'" v-model="form.hold_reason" :error="form.errors.hold_reason" class="pb-8 pr-6 w-full" label="Hold Reason">
                  <option v-for="(value, key) in hold_reasons" :value="key" :selected="key === order.hold_reason">{{ value }}</option>
                </select-input>

                <textarea-input v-show="form.status === 'cancelled' && form.cancel_reason === 'other'" v-model="form.cancel_reason_other" :error="form.errors.cancel_reason_other" class="pb-8 pr-6 w-full" label="Other Cancel Reason" />
                <loading-button :loading="form.processing" class="btn-indigo mb-5" type="submit">Save</loading-button>
              </div>
            </div>
          </form>
          <div class="mb-2 border-t" />
          <form @submit.prevent="add_note">
            <div class="flex flex-wrap w-full">
              <textarea-input v-model="note.note" :error="note.errors.note" class="pb-8 w-full" label="Note" />
              <loading-button :loading="note.processing" class="btn-indigo mb-10" type="submit">Add Note</loading-button>
            </div>
          </form>
        </div>
      </div>
    </div>


    <h2 class="mt-6 text-2xl font-bold">Items</h2>
    <div class="mt-6 bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6" />
          <th class="pb-4 pt-6 px-6">Product</th>
          <th class="pb-4 pt-6 px-6">SKU</th>
          <th class="pb-4 pt-6 px-6">Quantity</th>
          <th class="pb-4 pt-6 px-6">Price</th>
        </tr>
        <tr v-for="item in order.line_items" :key="item.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t" style="width: 100px">
<!--            <img  alt="" />-->
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/contacts/${item.id}/edit`">
              {{ item.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/contacts/${item.id}/edit`" tabindex="-1">
              {{ item.sku }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/contacts/${item.id}/edit`" tabindex="-1">
              {{ item.quantity }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="`/contacts/${item.id}/edit`" tabindex="-1">
              ₹  {{ item.price }}
            </Link>
          </td>
        </tr>
        <tr v-if="order.line_items.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">No items found.</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import TextareaInput from '@/Shared/TextareaInput'

export default {
  components: {
    TextareaInput,
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    order: Object,
    cancel_reasons: Array,
    hold_reasons: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        status: this.order.status,
        cancel_reason: this.order.cancel_reason,
        cancel_reason_other: '',
        hold_reason: this.order.hold_reason,
      }),
      note: this.$inertia.form({
        note: '',
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/orders/${this.order.id}`)
    },

    add_note() {
      this.note.put(`/orders/${this.order.id}/note`)
    },

    destroy() {
      if (confirm('Are you sure you want to delete this organization?')) {
        this.$inertia.delete(`/organizations/${this.organization.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this organization?')) {
        this.$inertia.put(`/organizations/${this.organization.id}/restore`)
      }
    },
  },
}
</script>
